import React, { useCallback } from 'react';
import styled from 'styled-components';
import throttle from 'lodash/throttle';
import theme from '@/styles/theme';

export interface BasicButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  fontWeight?: number;
  bgColor: string;
  borderColor?: string;
  textColor?: string;
  fontSize?: number;
  padding?: string;
  text?: string;
  disabled?: boolean;
  rightElement?: React.ReactElement;
  leftElement?: React.ReactElement;
  children?: React.ReactElement;
  delay?: number;
}

const ButtonComponent = (props: BasicButtonProps) => {
  const {
    fontWeight = 600,
    text = '버튼',
    textColor = theme.DF_COLOR.WHITE,
    fontSize = 18,
    padding = '1.1rem',
    children,
    disabled = false,
    leftElement,
    rightElement,
    borderColor,
    bgColor = theme.DF_COLOR.PRIMARY500,
    delay = 1000,
    onClick,
    ...buttonProps
  } = props;

  const persistedHandleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.persist();

    if (onClick) {
      onClick(event);
    }
  };

  const throttleOnClick = useCallback(
    throttle(persistedHandleClick, delay, { trailing: false }),
    [onClick, delay]
  );

  return (
    <ButtonRoundBox
      disabled={disabled}
      bgColor={bgColor}
      borderColor={borderColor}
      textColor={textColor}
      fontWeight={fontWeight}
      fontSize={fontSize}
      padding={padding}
      onClick={throttleOnClick}
      {...buttonProps}>
      {leftElement && <Left>{leftElement}</Left>}
      {children ? children : text}
      {rightElement && <Right>{rightElement}</Right>}
    </ButtonRoundBox>
  );
};

export default ButtonComponent;

const ButtonRoundBox = styled.button<{
  bgColor: string;
  borderColor?: string;
  textColor: string;
  fontWeight: number;
  fontSize: number;
  padding: string;
}>`
  ${({ bgColor, borderColor, textColor, fontWeight, fontSize, padding }) => `

  ${borderColor ? `border: 1px solid ${borderColor};` : ''}
  background: ${bgColor};
  color: ${textColor};
  padding: ${padding};
  border-radius: 5px;
  font-weight: ${fontWeight};
  font-size: ${fontSize}px;
  &:hover {
    opacity: 0.7;
    cursor: pointer;
    ${bgColor === '#fff' && 'background: #F9F9F9'}
  }

  &:disabled {
    background: ${theme.DF_COLOR.GRAY100};
    border-color: ${theme.DF_COLOR.GRAY100};
    color: ${theme.DF_COLOR.WHITE};
  }
`}
`;

const Right = styled.div`
  padding-left: 10px;
  display: flex;
`;

const Left = styled.div`
  padding-right: 10px;
  display: flex;
`;
